import { render } from "./VabeneIngredientBaseList.vue?vue&type=template&id=9bf047d2&scoped=true&ts=true"
import script from "./VabeneIngredientBaseList.vue?vue&type=script&lang=ts"
export * from "./VabeneIngredientBaseList.vue?vue&type=script&lang=ts"

import "./VabeneIngredientBaseList.vue?vue&type=style&index=0&id=9bf047d2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf047d2"]])

export default __exports__